// default values
export const BLANK=""
export const EMPTY_ARRAY=[]
export const EMPTY_OBJ={}
// js builtins

// math
export const { random, trunc } = Math

//object
export const { keys, values, entries } = Object

// font sizes
export const TITLE = 40
export const H1 = 32
export const H2 = 24
export const H3 = 20
export const H4 = 18
export const H5 = 16
export const H6 = 14
export const PARAGRAPH = 12
export const PHONE = "512-228-6673"
export const DUMMY =
    `Lorem ipsum dolor sit amet, consectetur 
    adipiscing elit, sed do eiusmod tempor incididunt ut 
    labore et dolore magna aliqua. Ut enim ad minim veniam, 
    quis nostrud exercitation ullamco laboris nisi ut 
    aliquip ex ea commodo consequat. Duis aute irure dolor in 
    reprehenderit in voluptate velit esse cillum dolore eu fugiat 
    nulla pariatur. Excepteur sint occaecat cupidatat non proident, 
    sunt in culpa qui officia deserunt mollit anim id est laborum. 
    Sed ut perspiciatis unde omnis iste natus error sit voluptatem 
    accusantium doloremque laudantium, totam rem aperiam, eaque ipsa 
    quae ab illo inventore veritatis et quasi architecto beatae vitae 
    dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit 
    aspernatur aut odit aut fugit, sed quia consequuntur magni dolores 
    eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam 
    est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci 
    velit, sed quia non numquam eius modi tempora incidunt ut labore 
    et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima 
    veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, 
    nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure 
    reprehenderit qui in ea voluptate velit esse quam nihil molestiae 
    consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla 
    pariatur?`

